module.exports = __webpack_public_path__ + "static/media/logo_black.8efd6ec8.svg";